interface Marketor {
  id: number;
  twitch_user_id: string;
  twitch_display_name: string;
  email: string;
  name: string;
  refid: string;
  created_at: string;
  updated_at: string;
}

interface ViewMarketorModalProps {
  isOpen: boolean;
  onClose: () => void;
  marketor: Marketor | null;
}

const ViewMarketorModal = ({ isOpen, onClose, marketor }: ViewMarketorModalProps) => {
  if (!isOpen || !marketor) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-1000">
      <div className="gothic-panel w-full max-w-md">
        <h2 className="gothic-heading">View Marketor</h2>
        <div className="space-y-4">
          <p className="gothic-text-silver"><strong className="gothic-text-gold">ID:</strong> {marketor.id}</p>
          <p className="gothic-text-silver"><strong className="gothic-text-gold">Twitch User ID:</strong> {marketor.twitch_user_id}</p>
          <p className="gothic-text-silver"><strong className="gothic-text-gold">Twitch Display Name:</strong> {marketor.twitch_display_name}</p>
          <p className="gothic-text-silver"><strong className="gothic-text-gold">Email:</strong> {marketor.email}</p>
          <p className="gothic-text-silver"><strong className="gothic-text-gold">Name:</strong> {marketor.name}</p>
          <p className="gothic-text-silver"><strong className="gothic-text-gold">Ref ID:</strong> {marketor.refid}</p>
          <p className="gothic-text-silver"><strong className="gothic-text-gold">Created At:</strong> {new Date(marketor.created_at).toLocaleString()}</p>
          <p className="gothic-text-silver"><strong className="gothic-text-gold">Updated At:</strong> {new Date(marketor.updated_at).toLocaleString()}</p>
          <div className="flex justify-end">
            <button onClick={onClose} className="gothic-button">Close</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewMarketorModal;